import React from 'react';
import { SanitizedHtml } from "wup-module1-base";

const WindowText = (data) => {

  return (
    <>
      <div className="text-box">
        <div className="title-box1">
          <div className="title-1">{data.title}</div>
        </div>

        <div className="description-box-2">
          <div className={data.class}>
            <SanitizedHtml html={data.description} />
          </div>
        </div>
      </div>
    </>
  );
};

export default WindowText;